<!-- Chat Toggle Button (FAB) -->
<button 
  mat-fab
  color="primary"
  class="chat-fab"
  (click)="toggleChat()"
  [class.hidden]="isChatOpen"
  matTooltip="Nora AI">
  <img class="chat-fab-icon" src="assets/nora3.png" alt="Nora AI" />
</button>

<!-- Chat Panel -->
<div class="chat-panel" [class.open]="isChatOpen">
  <!-- Panel Content (when panel is open) -->
  @if (isChatOpen) {
<div class="chat-panel-content">
    <div class="chat-header">
      <div class="header-content">
        <img class="nora-icon nora-icon--2x" src="assets/nora3.png" alt="Nora AI" />
        <h3>Nora AI</h3>
      </div>
      <div class="header-actions">
        <button 
          mat-icon-button
          (click)="toggleSessionList()"
          matTooltip="Conversation History">
          <mat-icon>history</mat-icon>
        </button>
        <button 
          mat-icon-button
          (click)="startNewConversation()"
          matTooltip="New Conversation">
          <mat-icon>add_comment</mat-icon>
        </button>
        <button 
          mat-icon-button
          (click)="toggleChat()"
          matTooltip="Close Panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

  <!-- Session List Sidebar -->
  <div class="session-list" [class.visible]="showSessionList">
    <div class="session-list-header">
      <h4>Recent Conversations</h4>
      <button mat-icon-button (click)="toggleSessionList()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    @if (sessions.length > 0) {
<mat-nav-list>
      @for (session of sessions; track session) {
<mat-list-item 
       
        (click)="loadSessionHistory(session)"
        class="session-item">
        <mat-icon matListItemIcon>chat_bubble_outline</mat-icon>
        <div matListItemTitle>{{ session.title || 'Untitled Conversation' }}</div>
        <div matListItemLine>{{ session.lastMessageAt | utcDate:'short' }}</div>
      </mat-list-item>
}
    </mat-nav-list>
}
    @if (sessions.length === 0) {
<div class="empty-sessions">
      <mat-icon>chat_bubble_outline</mat-icon>
      <p>No previous conversations</p>
    </div>
}
  </div>

  <!-- Messages Area -->
  <div class="chat-messages" #messagesContainer>
    <!-- History Notice Banner -->
    @if (isViewingHistory && messages.length > 0) {
<div class="history-notice">
      <mat-icon>info</mat-icon>
      <span>This is a past conversation. The AI does not have memory of previous sessions.</span>
    </div>
}

    @if (isLoadingHistory) {
<div class="loading-indicator">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading conversation...</p>
    </div>
}

    @if (!isLoadingHistory && messages.length === 0) {
<div class="welcome-message">
      <img class="welcome-icon" src="assets/nora3.png" alt="Nora AI" />
      <h4>Hi! I am NORA - AMORE team's AI Agent</h4>
      <p>Ask me about your portfolio of applications — candidates for modernization, comparisons, readiness scores, and more.</p>
      <div class="example-queries">
        <p class="example-label">Try asking:</p>
        <mat-chip-listbox>
          <mat-chip-option
            (click)="sendMessage('Show me my top 10 modernization candidates')">
            "Top 10 modernization candidates"
          </mat-chip-option>
          <mat-chip-option
            (click)="sendMessage('How many applications are on-premise vs cloud?')">
            "On-premise vs cloud"
          </mat-chip-option>
          <mat-chip-option
            (click)="sendMessage('Give me a portfolio overview')">
            "Portfolio overview"
          </mat-chip-option>
          <mat-chip-option
            (click)="sendMessage('Show high-priority modernization candidates')">
            "High-priority candidates"
          </mat-chip-option>
          <mat-chip-option
            (click)="sendMessage('Help me refresh CMDB readiness scoring for an application')">
            "Refresh CMDB readiness scoring"
          </mat-chip-option>
          <mat-chip-option
            (click)="sendMessage('Help me run lightweight code validation for an application')">
            "Run lightweight code validation"
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </div>
}

    @for (message of messages; track message; let i = $index) {
<app-chat-message 
     
      [message]="message"
      [isLastMessage]="i === messages.length - 1"
      (quickReply)="sendMessage($event)">
    </app-chat-message>
}

    @if (isTyping) {
<div class="typing-indicator-container">
      <app-typing-indicator></app-typing-indicator>
    </div>
}

    @if (error) {
<div class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
}
  </div>

    <!-- Input Area -->
    <app-chat-input
      [disabled]="isTyping"
      (messageSent)="sendMessage($event)">
    </app-chat-input>
  </div>
}
</div>
